import { useMemo } from "react";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererBody } from "./ContentRendererBody";
import { LandingHero } from "../LandingHero/LandingHero";
import { CommonContainerPropsComponent } from "../../../api/content-client/service";

interface Props {
  body?: any;
  buttonPrimaryLink?: string;
  buttonPrimaryTitle?: string;
  buttonSecondaryLink?: string;
  buttonSecondaryTitle?: string;
  containerProps?: CommonContainerPropsComponent;
  isCentered?: boolean;
  media?: any;
  noBgGradient?: boolean;
  title?: string;
}

export function ContentRendererHero(block: Props) {
  const {
    body,
    buttonPrimaryLink,
    buttonPrimaryTitle,
    buttonSecondaryLink,
    buttonSecondaryTitle,
    containerProps,
    isCentered,
    media,
    noBgGradient,
    title,
  } = block || {};

  const isFullWidth = containerProps?.maxWidth === "full";

  const computedBody = useMemo(() => {
    if (body?.[0]?.children?.[0]?.text) {
      return body;
    }
    return [{ type: "paragraph", children: [{ text: " ", type: "text" }] }];
  }, [body]);

  const renderLandingComponent = () => (
    <LandingHero
      buttonPrimaryLink={buttonPrimaryLink}
      buttonPrimaryTitle={buttonPrimaryTitle}
      buttonSecondaryLink={buttonSecondaryLink}
      buttonSecondaryTitle={buttonSecondaryTitle}
      image={media?.data?.attributes?.url}
      isCentered={isCentered}
      title={title}
      isFullWidth={isFullWidth}
      noBgGradient={noBgGradient}
    >
      <ContentRendererBody
        body={computedBody}
        paragraphVariant="bodyLg"
        paragraphSx={{
          minHeight: 29,
          color: "primary.contrastText",
          display: "-webkit-box",
          overflow: "hidden",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 4,
          maxWidth: {
            xs: "100%",
            sm: "60%",
            md: "50%",
          },
        }}
      />
    </LandingHero>
  );

  if (isFullWidth) {
    return renderLandingComponent();
  }

  return (
    <ContentRendererContainer containerProps={containerProps}>{renderLandingComponent()}</ContentRendererContainer>
  );
}
